export default __webpack_public_path__ + "static/media/Critter.f527ff53.png";